var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocatie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99888 8.76904C2.7737 9.31861 1.99805 10.1136 1.99805 11.0013C1.99805 12.6587 4.68517 14.0026 8.00055 14.0026C11.3159 14.0026 14.003 12.6587 14.003 11.0013C14.003 10.1136 13.2274 9.31861 12.0022 8.76904",
    stroke: "#F2EBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4358 11.3347C9.71307 11.805 8.86164 12.0381 8.00013 12.0017C7.13863 12.0381 6.2872 11.805 5.56445 11.3347",
    stroke: "#F2EBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46782 2.60644C10.0624 3.20099 10.2403 4.09515 9.9185 4.87198C9.59674 5.64881 8.8387 6.15532 7.99787 6.15532C7.15704 6.15532 6.399 5.64881 6.07724 4.87198C5.75548 4.09515 5.93335 3.20099 6.52793 2.60644C6.9177 2.21644 7.44649 1.99731 7.99787 1.99731C8.54926 1.99731 9.07804 2.21644 9.46782 2.60644",
    stroke: "#F2EBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00046 6.15393V10.0009",
    stroke: "#F2EBEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocatie);
export default __webpack_public_path__ + "static/media/Locatie.87e8df0f9b799dc0f8f3fcef7c64197d.svg";
export { ForwardRef as ReactComponent };